import { Component, Input } from '@angular/core';
import { NgClass } from '@angular/common';

@Component({
  selector: 'app-section',
  imports: [NgClass],
  templateUrl: './section.component.html',
  styleUrls: ['./section.component.scss'],
})
export class SectionComponent {
  @Input() type: 'default' | 'light' = 'default';
  @Input() top?: boolean;
  @Input() bottom?: boolean;
  @Input() gap: 'default' | 'small' | 'none' = 'default';
  @Input('z-index') zIndex?: 'low' | 'high';
}
